










































































import Vue from 'vue'
import Component from 'vue-class-component';

@Component
export default class Permits extends Vue {
    name: string = 'Permits';
    isLoading: boolean = true;

    mounted() {
        this.isLoading = false;
    }
}
